import { FALLBACK_IMAGE } from './constants';
import { imageDefinition } from './imageDefinition';
import { imageUrlBuilder } from './imageUrlProvider/imageUrlProvider';

// The one definition of the generic fallback image, shared by every surface that can show it.
// Always built at the thumbnail definition: the asset is 869x869, so the larger definitions
// (fabricInfo asks for 900/1600) would upscale it, and the thumbnail widths are the variants
// Cloudinary already has derived.
export const buildGenericFallbackImageData = (cdnDomain: string) =>
  imageUrlBuilder({
    imageUrls: [FALLBACK_IMAGE],
    imageDefinition: imageDefinition.thumbnail,
    cdnDomain,
  });

// The asset is a transparent PNG with a grey glyph, so it needs a background to sit on and must
// not be stretched to fill the box like a real fabric image.
export const FALLBACK_IMAGE_CONTAINER_CLASSES = 'bg-gray-200';
export const FALLBACK_IMAGE_CLASSES = 'object-contain scale-[0.22]';
